export const htmlDefaultValues = {
  name: 'WPP Open Platform',
  title: 'Welcome to WPP Open Platform',
  description:
    "A SaaS-based solution to enable WPP organisation's users to access many products and a set of common shared services.",
  faviconHref: 'assets/wpp-favicon.ico',
}
